import React from 'react'


import axios from "axios";
import Swal from 'sweetalert2'

import config from "../../config"


import { useNetworkState } from 'react-use';

import Footer from './Footer';
import Header from './Header';

import Modal from 'react-bootstrap/Modal';

import ReactLoading from 'react-loading';
const Pickup_request_b2b = () => {
    const getFormattedDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    const [state, setState] = React.useState([])
    const [filters, setfilters] = React.useState({ request_id: "", pickup_date: getFormattedDate() })
    const [modalpickupState, setModalpickupState] = React.useState({ show: false });
    const [addressState, setaddressState] = React.useState([]);
    const [pickupstate, setpickupstate] = React.useState({ warehouse_name: "" });
    const [selectedDateTime, setSelectedDateTime] = React.useState(null);
    const [selectedTime, setSelectedTime] = React.useState('14:00');
    const [loaderpickup, setloaderpickup] = React.useState(false)
    let userDetail = localStorage.getItem('ship_rocket_user');
    // console.log("userDetail====", config.UserId);
    let userData = {};
    if (userDetail != null) {
        userData = JSON.parse(userDetail)
    }
    const isOnline = useNetworkState();
    console.log("isONline  === ", isOnline)


    React.useEffect(() => {
        pickup_detail()
        address_book_detail()
    }, [])

    const pickup_detail = () => {
        let url = config.apiUrl + '/shipment/pickup_request_details';
        let sendData = { customer_id: userData.customer_id, carrier_type: "B2B" };
        if (filters.pickup_date != "") {
            sendData.pickup_date = filters.pickup_date
        }
        if (filters.request_id != "") {
            sendData.request_id = filters.request_id
        }
        // console.log("bb", sendData);
        axios.post(url, sendData, { headers: config.headers }).then((res) => {

            // console.log("sasdfdsa")
            setState(res.data.output)



        }).catch(() => {
            const Toast = Swal.mixin({
                toast: true,
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000
            })

            Toast.fire({
                background: "#a61c09",
                type: 'unsuccess',
                title: "Something Went Wrong",
                color: "white"
            });


        })
    }

    const handleChange = (e) => {
        setfilters({ ...filters, [e.target.name]: e.target.value })
    }

    const openPickupModal = (sub) => {
        // console.log("sub===== " , sub)

        setModalpickupState({ ...modalpickupState, show: true })

    }

    const inputHandleChangemodal = (e) => {
        setpickupstate({ ...pickupstate, warehouse_name: e.target.value })
    }

    const pickup_request = () => {
        if (isOnline.online == true) {
            let url = config.apiUrl + '/shipment/create_pickup_request_api';
            if (pickupstate.warehouse_name != "") {
                if (selectedDateTime != null) {
                    if (selectedTime != null) {
                        setloaderpickup(true)
                        let sendData = { customer_id: userData.customer_id, warehouse_name: pickupstate.warehouse_name, date: selectedDateTime, time: selectedTime };
                        // console.log("pickup_request === ", sendData);
                        axios.post(url, sendData, { headers: config.headers }).then((res) => {
                            if (res.data.status == true) {
                                setModalpickupState({ show: false })
                                setloaderpickup(false)

                                const allMessages = res.data.message.map((shipmentMessage) => {
                                    console.log("shipmentMessage == ", shipmentMessage)
                                    return `${shipmentMessage}`;
                                }).join('\n');
                                const Toast = Swal.mixin({
                                    toast: true,
                                    position: 'bottom-end',
                                    showConfirmButton: false,
                                    timer: 10000
                                })

                                Toast.fire({
                                    background: "#3659cd",
                                    type: 'success',
                                    width: '600px',
                                    title: allMessages,
                                    color: "white",
                                });

                                pickup_detail()
                                // // console.log("sasdfdsa")

                            }
                            else {
                                setModalpickupState({ show: false })
                                setloaderpickup(false)
                                const allMessages = res.data.message.map((shipmentMessage) => {
                                    console.log("shipmentMessage == ", shipmentMessage)
                                    return `${shipmentMessage}`;
                                }).join('\n');
                                const Toast = Swal.mixin({
                                    toast: true,
                                    position: 'bottom-end',
                                    showConfirmButton: false,
                                    timer: 10000
                                })

                                Toast.fire({
                                    background: "#a61c09",
                                    type: 'unsuccess',
                                    width: '600px',
                                    title: allMessages,
                                    color: "white",
                                });


                            }

                        }).catch(() => {
                            setModalpickupState({ show: false })
                            setloaderpickup(false)
                            const Toast = Swal.mixin({
                                toast: true,
                                position: 'bottom-end',
                                showConfirmButton: false,
                                timer: 10000
                            })

                            Toast.fire({
                                background: "#a61c09",
                                type: 'unsuccess',
                                title: "Something Went Wrong",
                                color: "white"
                            });


                        })
                    } else {
                        const Toast = Swal.mixin({
                            toast: true,
                            position: 'bottom-end',
                            showConfirmButton: false,
                            timer: 3000
                        })

                        Toast.fire({
                            background: "#a61c09",
                            type: 'unsuccess',
                            title: "Please Select Time",
                            color: "white"
                        });
                    }
                } else {

                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'bottom-end',
                        showConfirmButton: false,
                        timer: 3000
                    })

                    Toast.fire({
                        background: "#a61c09",
                        type: 'unsuccess',
                        title: "Please Select Date",
                        color: "white"
                    });
                }
            } else {

                const Toast = Swal.mixin({
                    toast: true,
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 3000
                })

                Toast.fire({
                    background: "#a61c09",
                    type: 'unsuccess',
                    title: "Please Select All",
                    color: "white"
                });
            }
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: "Network Connection Error",

            })
        }
    }

    const selectTime = (e) => {
        setSelectedTime(e.target.value)
    }

    const address_book_detail = () => {
        let url = config.apiUrl + '/country/address_book';
        let sendData = { customer_id: userData.customer_id };
        // console.log("bb", sendData);
        axios.post(url, sendData, { headers: config.headers }).then((res) => {
            if (res.data.status == true) {
                // console.log("sasdfdsa")
                setaddressState(res.data.output)
                // setState([])
                // setCityList([])
                // setPincodeList([])
                // setaddState({...addstate, full_name:"" ,  state_name:"" , city_name:"" , pincode:"" , address:"" , email:"" , mobile:"" , warehouse_name:"", err:{} })
                // setOptions([])


            }

        }).catch(() => {
            const Toast = Swal.mixin({
                toast: true,
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000
            })

            Toast.fire({
                background: "#a61c09",
                type: 'unsuccess',
                title: "Something Went Wrong",
                color: "white"
            });


        })
    }

    const getNext5Dates = () => {
        const today = new Date();
        const now = new Date(); // Get the current time

        const nextDates = [];

        // Check if the current time is before 1:00 PM
        if (now.getHours() < 14) {
            // Show today's date
            nextDates.push(formatDate(today));
        }

        // Calculate and show the dates for the next 4 days
        for (let i = 1; i < 5; i++) {
            const nextDate = new Date(today);
            nextDate.setDate(today.getDate() + i);
            nextDate.setHours(today.getHours());
            nextDate.setMinutes(today.getMinutes());
            nextDates.push(formatDate(nextDate));
        }

        return nextDates;
    };
    const formatDate = (date) => {
        const options = { day: 'numeric', month: 'long', year: 'numeric' };
        return date.toLocaleDateString(undefined, options);
    };
    const nextDates = getNext5Dates();
    const handleDateSelect = (date) => {
        setSelectedDateTime(date);
        // You can also close the modal or perform other actions here
    };
    return (

        <div>
            <Header />
            <Modal show={modalpickupState.show} onHide={() => setModalpickupState({ show: false })} size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title> <h4 class="modal-title">Schedule Your Pickup</h4></Modal.Title>
                </Modal.Header>
                <Modal.Body >

                    <div class="modal-body">
                        <div class="row booking_info_bx">

                            <div class="col-12 col-md-12 mb-3">
                                <div class="card bg-light border-0 shadow-sm">
                                    <div class="card-body">
                                        <div class="d-flex">
                                            <div class="p-2 text-primary">
                                                <i class="bi bi-truck"></i>
                                            </div>
                                            <div class="ps-4 ">
                                                <h6>Pickup Address</h6>
                                                <select class="form-select" name="warehouse_name" onChange={(e) => inputHandleChangemodal(e)}>
                                                    <option>Select</option>
                                                    {addressState.map((sub) => {
                                                        return (
                                                            <option value={sub.address_id}>{sub.warehouse_id} - {sub.address}</option>
                                                        )

                                                    })}

                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-12 mb-3">
                                <div class="card bg-light border-0 shadow-sm">
                                    <div class="card-body">
                                        <div class="d-flex">
                                            <div class="p-2 text-primary">
                                                <i class="bi bi-calendar"></i>
                                            </div>
                                            <div class="ps-4 shcelu_pil">
                                                <h6>Schedule Your Pickup</h6>
                                                <small>Please select a suitable date and time for the pickup.</small>
                                                <div class=" mt-3">
                                                    <div className="d-flex mt-3">

                                                        {nextDates.map((date, index) => (
                                                            <>
                                                                <button
                                                                    type="button"
                                                                    className={`me-2 mb-2 px-3 py-2 rounded border fw-semibold 
              ${selectedDateTime === date ? "text-dark border-danger bg-light" : "text-secondary border-light bg-white"}
              shadow-sm`}
                                                                    style={{ minWidth: "100px" }}
                                                                    key={index}
                                                                    onClick={() => handleDateSelect(date)}
                                                                >
                                                                    {date}
                                                                </button>
                                                            </>
                                                        ))}
                                                    </div>
                                                    {selectedDateTime && <p>Selected Date: {(selectedDateTime)} </p>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer text-start">
                        {loaderpickup == true ? <ReactLoading type={"spin"} color={"#0d6efd"} height={40} width={60} /> : <button type="button" class="btn btn-primary" data-bs-dismiss="modal" onClick={() => pickup_request()}>Schedule Pickup</button>}
                        <button type="button" class="btn btn-outline-danger" data-bs-dismiss="modal" onClick={() => setModalpickupState({ show: false })}>I'll Do this later</button>
                    </div>


                </Modal.Body>

            </Modal>
            <div class="page-wrapper pinned">
                <div class="main-container">
                    <div className='app-container'>
                        <div class="app-body">
                            <div class="container-fluid">
                                <div class="row mb-2">
                                    <div class="col-12 col-md">
                                        <div class="d-flex">


                                            <a href="javascript:window.history.back();" class="back_btn"><i class="bi bi-arrow-90deg-left"></i></a>
                                            <h2>Pickup Request B2B</h2>

                                        </div>
                                    </div>

                                </div>
                                <div class="row mb-2">
                                    <div class="col-12 col-md">
                                        <div class="row g-1">
                                            <div class="col-12 col-md-3">
                                                <div class="input-group input-group-sm mb-3">

                                                    <input type="text" class="form-control w-50" name="request_id" placeholder="Enter Request ID" onChange={(e) => handleChange(e)} />

                                                </div>
                                            </div>

                                            <div class="col-6 col-md-3 ms-3">
                                                <input type="date" class="form-control form-control-sm" id="text" placeholder="Enter details name=" name="pickup_date" value={filters.pickup_date} onChange={(e) => handleChange(e)}
                                                />
                                            </div>

                                            <div class="col-6 col-md-2 ms-3">
                                                <button class="btn btn-outline-primary btn-sm" onClick={(e) => pickup_detail()} >Search</button>




                                            </div>
                                            <div className='col-6 col-md-2 ms-3'>
                                                <button type="button" class="btn btn-outline-secondary" onClick={() => openPickupModal()}><i class="bi bi-clock"></i> Schedule Pickups</button>
                                            </div>



                                        </div>
                                    </div>
                                </div>
                                <div className='mb-2'>
                                    <strong className='text-primary'>Please note that Shipments booked as 'Self Drop' will not be picked by the courier partner</strong>
                                </div>

                                <div class="content-wrapper-data">
                                    <div class="card border-0">
                                        <div class="card-body">
                                            <div class="table-data table-responsive">
                                                <table class="table table-hover table-responsive">
                                                    <thead>
                                                        <tr class="table-light">
                                                            <th>Request ID</th>
                                                            <th>Pickup Point</th>
                                                            <th>Pickup Date/Time</th>
                                                            <th>Package Count</th>
                                                            <th>Delivery Partner</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {state.map((sub) => (
                                                            <tr class="ship-now-container">
                                                                <td>
                                                                    <a href="#">{sub.pickup_id}</a>
                                                                </td>
                                                                <td>
                                                                    {sub.warehouse_id ? sub.warehouse_id : sub.warehouse_name}
                                                                </td>
                                                                <td>
                                                                    {sub.pickup_date}<br />
                                                                    <small>{sub.pickup_time}</small>
                                                                </td>
                                                                <td>
                                                                    {sub.package_count}
                                                                </td>
                                                                <td class="channel_logo">
                                                                    {sub.service_provider}
                                                                </td>


                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                            </div></div>
                        <Footer /></div></div></div>









        </div>
    )
}

export default Pickup_request_b2b
